import React from 'react';

interface Props {
    char: string,
    active: boolean,
    onClick: (char: string) => void
}
export default function AlphaChar({ char, active, onClick }: Props) {

    return (
        <>
            <a className={`pr-3 cursor ${(char === 'all') ? 'pl-3' : ''} ${(active) ? 'text-primary text-bold' : ''}`} onClick={() => onClick(char)} style={{ textDecoration: 'none' }}>
                <strong className={`${(char === 'all') ? 'text-capitalize' : 'text-uppercase'}`}>
                    {char}
                </strong>
            </a>
        </>
    )
}